var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticStyle:{"height":"130px"}},[_c('v-layout',{attrs:{"mx-3":"","pt-5":"","row":"","wrap":"","justify-center":""}},[_c('h3',[_vm._v("Este pedido expirou em "+_vm._s(_vm.expired))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }